import { render, staticRenderFns } from "./style_colors_upload.vue?vue&type=template&id=d5c2a906&scoped=true&"
import script from "./style_colors_upload.vue?vue&type=script&lang=js&"
export * from "./style_colors_upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c2a906",
  null
  
)

export default component.exports